/* import __COLOCATED_TEMPLATE__ from './summary-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();